import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './styles/urdu-font.css';
import { AuthProvider } from "./context/AuthContext";
// import { ThemeProvider } from './context/ThemeContext';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { DiffCacheProvider } from './context/DiffCacheContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DiffCacheProvider>
    <AuthProvider>
      {/* <ThemeProvider> */}
        <App />
      {/* </ThemeProvider> */}
    </AuthProvider>
    </DiffCacheProvider>
  </React.StrictMode>
);
